import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DataAndMap from './containers/DataAndMap';
import ChooseDialog from './components/ChooseDialog';
import Finished from './components/Finished';

import './style/style.css';

const pages = {
  ChooseDialog,
  DataAndMap,
  Finished,
};

const mapState = ({ page }) => ({ page });

const RouteContainer = ({ page }, ...props) => {
  const Page = pages[page];
  return Page ? <Page props={props} /> : null;
};

RouteContainer.defaultProps = {
  page: ChooseDialog,
};

RouteContainer.propTypes = {
  page: PropTypes.string.isRequired,
};

class App extends React.Component {
  render() {
    // console.dir(this.props);
    const { page } = this.props;
    return (
      <RouteContainer page={page} />
    );
  }
}

App.defaultProps = {
  page: ChooseDialog,
};

App.propTypes = {
  page: PropTypes.string.isRequired,
};

export default connect(mapState)(App);



// WEBPACK FOOTER //
// ./src/App.js